/* https://codepen.io/supah/pen/BjYLdW */
import { Component, OnInit, Input, ChangeDetectionStrategy, ElementRef, Renderer2, Optional } from '@angular/core';

import { LoadersComponent } from '../../loaders.shared.component';

@Component({
    selector: 'shared-loader-for-spinner',
    templateUrl: './loaders-spinner.shared.component.html',
    styleUrls: ['./loaders-spinner.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadersSpinnerComponent extends LoadersComponent implements OnInit {
    @Input() public size: OLO.Components.LOADER_SIZE;
    @Input() public brandAccent: boolean = false;

    constructor(
        @Optional() public elementRef: ElementRef,
        @Optional() public renderer2: Renderer2,
    ) {
        super();
    }

    ngOnInit(): void {
        if (this.elementRef && this.renderer2 && this.size) {
            this.renderer2.addClass(this.elementRef.nativeElement, `-size-${this.size}`);
        }
    }
}
